window.servicesVersionLaravelCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        css: {
            "background-color": row.laravel_color
        }
    };
};
